"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetNavigationType = exports.getBurgerMenuHeight = void 0;
var _hooks = require("../../hooks");
var _net = require("../../models/graphql-types/net");
const useGetNavigationType = ({
  link,
  activeLinkType
}) => {
  const isMobile = (0, _hooks.useIsMobile)();
  const isLinkTypeCatalogue = link?.linkType === _net.NavigationLinkType.Catalogue;
  const isActiveLinkTypeCatalogue = activeLinkType === _net.NavigationLinkType.Catalogue;
  const isCategory = activeLinkType === _net.NavigationLinkType.Category;
  const isInspiration = activeLinkType === _net.NavigationLinkType.Inspiration;
  const isBeautyAndTrends = activeLinkType === _net.NavigationLinkType.BeautyTips;
  const isBestOffers = activeLinkType === _net.NavigationLinkType.FocusPage;
  const isGifts = activeLinkType === _net.NavigationLinkType.Gifts;
  return {
    isCatalogue: isMobile ? isLinkTypeCatalogue : isActiveLinkTypeCatalogue,
    isCategory,
    isInspiration,
    isBeautyAndTrends,
    isBestOffers,
    isGifts
  };
};
exports.useGetNavigationType = useGetNavigationType;
const getBurgerMenuHeight = ({
  isActiveLink,
  isAlwaysActiveLink,
  burgerMenuHeight
}) => {
  if (isActiveLink) {
    return burgerMenuHeight;
  } else if (isAlwaysActiveLink) {
    return undefined;
  }
  return 0;
};
exports.getBurgerMenuHeight = getBurgerMenuHeight;